module.exports = __webpack_public_path__ + "887af4ebe7ffd14c0b118a01412396cc.jpg";